import React, { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import M_Footer from './M_Footer';
import './styles/App.css';
import axios from 'axios';
import parse from 'html-react-parser';
import queryString from 'query-string';
import { getByTestId } from '@testing-library/dom';
import TopTitle from './Pc_TopTitle';
import { comma, uncomma, instance } from './common';
import { getAllByPlaceholderText } from '@testing-library/react';



function LoadService({ s_id, option, setOption, goCart, onClick }) {
    // user logged in or anonymous
    let res = window.sessionStorage.result || JSON.stringify({
        u_type: 'anonymous',
        u_id: -1
    });
    let session = JSON.parse(res);
    let { u_type } = session;
    const [data, setData] = useState([]);
    const [showPrice, setPrice] = useState('');
    let obj = {
        s_id: s_id
    }
    useEffect(() => {

        const fetchData = async () => {
            instance.post('/service/id', obj).then(function (res) {
                
                setData(res.data[0]);
                if (u_type == '일반고객') {
                    setPrice(res.data[0].s_price);
                } else {
                    setPrice(res.data[0].s_member_price);
                }

            });

        };

        fetchData();

    }, []);

    let { s_cate,s_name, s_content, s_price, s_img, s_member_price, s_option, s_product } = data;

    if (s_content) {
        s_content = parse(s_content);
    }

    console.log('s_option : ', s_option)
    const verticalM = {
        verticalAlign: 'mdiddle'
    }

    const priceChange = (e) => {
        const { name, value, checked } = e.target;
        if (checked) {
            setPrice(Number(showPrice) + Number(value));
            setOption([...option, { name: name, price: value }]);
        } else {
            setPrice(Number(showPrice) - Number(value))
            setOption(option.filter(v => v.name !== name));
        }

    }

    const goAlert = () => {
        alert('로그인 후 사용가능한 서비스 입니다.');
        document.getElementById('login-text').click();
    }
    return (
        <>
            {/* <h4 className="my-5 s_mgauto font-weight-bold service_title" id="service_title1">{s_name}</h4>
        <h4 className="text-right w-100 text-primary">
            {comma(showPrice)}원
        </h4> */}
            <div className="container row mb-5 p-0">
                <div className="col-6 pl-0">
                    <img className="w-100" src={s_img} />
                </div>
                <div className="col-6">
                    <h2 className="font-weight-bold w-100" data-id={s_id} style={{ cursor: "pointer",paddingLeft:'15px',paddingRight:'15px' }}>{s_name}</h2>
                    {
                        s_option
                        ?
                        <div className="mt-5" style={{paddingLeft:'15px',paddingRight:'15px'}}>
                            <h5 className="font-weight-bold">[옵션 추가]</h5>
                            <ul>
                                {
                                    JSON.parse(s_option).map(v =>
                                        <li className="d-block">
                                            <label>
                                                <input name={v.name} className="pt-2 mr-2" style={verticalM} type="checkbox" value={v.price} onChange={priceChange} />
                                                {v.name} : {comma(v.price)}  원</label>
                                        </li>)
                                }
                            </ul>
                            {
                                s_product && <div className="font-weight-bold mt-3">{s_product}</div>
                            }
                            <div className="mt-5">
                                {
                                    s_cate === '썬가드하이퍼이벤트'
                                    ?
                                    <>
                                    <h5 data-id={s_id} className="font-weight-bold text-lightgray" style={{ textDecoration: 'line-through' }}>소비자가 : {comma(s_price)}원</h5>
                                    <h1 data-id={s_id} className="font-weight-bold specialHal">특별 할인가 : {comma(showPrice)}</h1>
                                    </>
                                    :
                                    u_type === '카마스터'
                                    ?
                                    <>
                                    <h5 data-id={s_id} className="font-weight-bold text-lightgray" style={{ textDecoration: 'line-through' }}>소비자가 : {comma(s_price)}원</h5>
                                    <h1 data-id={s_id} className="font-weight-bold specialHal">특별 할인가 : {comma(showPrice)}</h1>
                                    </>
                                    :<h1 data-id={s_id} className="font-weight-bold specialHal">소비자가 : {comma(showPrice)}원</h1>
                                }
                                
                            </div>
                        </div>
                        :
                        <div className="mt-5" style={{paddingLeft:'15px',paddingRight:'15px'}}>
                            {
                                s_product && <div className="font-weight-bold mt-3">{s_product}</div>
                            }
                            <div className="mt-5">
                                {
                                    u_type === '카마스터'
                                    ?
                                    <>
                                    <h5 data-id={s_id} className="font-weight-bold text-lightgray" style={{ textDecoration: 'line-through' }}>소비자가 : {comma(s_price)}원</h5>
                                    <h1 data-id={s_id} className="font-weight-bold specialHal">특별 할인가 : {comma(showPrice)}</h1>
                                    </>
                                    :<h1 data-id={s_id} className="font-weight-bold specialHal">소비자가 : {comma(showPrice)}원</h1>
                                }
                            </div>
                        </div>
                    }
                    

                    <div className="bottomDownMenu" >
                        {
                            (u_type === '카마스터' || u_type === '일반고객')
                            ? 
                            <>
                                <div className="thisIlBtn">
                                    <div className="col-6">
                                        <div className="thisCustomBtn btn-block" onClick={goCart}>장바구니</div>
                                    </div>
                                    <div className="col-6">
                                        <div className="thisCustomBtn2  btn-block" onClick={onClick}>서비스 신청하기</div>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="thisIlBtn">
                                    <div className="col-6">
                                        <div className="thisCustomBtn  btn-block" onClick={goAlert}>장바구니</div>
                                    </div>
                                    <div className="col-6">
                                        <div className="thisCustomBtn2  btn-block" onClick={goAlert}>서비스 신청하기</div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>

                </div>
            </div>

            <div className="s_mbdown w-100">
                <div className="s_content" id="s_content">{s_content}</div>
            </div>
        </>
    );
}

function Pc_ServiceInfo({ location, match, history }) {


    const [option, setOption] = useState([]);
    const goBack = () => {
        history.goBack();
    };

    const query = queryString.parse(location.search);
    let s_id = query.s_id;


    // user logged in or anonymous
    let res = window.sessionStorage.result || JSON.stringify({
        u_type: 'anonymous',
        u_id: -1
    });
    let session = JSON.parse(res);
    let { u_id } = session;

    const onClick = () => {
        if (u_id === -1) {
            alert('로그인이 필요합니다');
            return;
        }
        
        const obj = { s_id: s_id, u_id: u_id, c_option: option.length !== 0 ? JSON.stringify(option) : null };
        const fetchData = async () => {
            instance.post('/cart/direct', { obj: obj }).then(function (res) {
                if (query.r_id) {
                    history.push('/cart?r_id=' + query.r_id);
                } else {
                    history.push('/cart');
                }

            });

        };

        fetchData();

    }


    const goCart = () => {
        if (u_id === -1) {
            alert('로그인이 필요합니다');
            return;
        }

        const obj = { s_id: s_id, u_id: u_id, c_option: option.length !== 0 ? JSON.stringify(option) : null };
        const fetchData = async () => {
            instance.post('/cart/insert', { obj: obj }).then(function (res) {
                alert(res.data.msg);
            });

        };

        fetchData();


    }
    return (
        <>
            <Container className="position-relactive p-0">
                <Row className="mb-5">
                    <div style={{ marginBottom: '10px' }} className="row col-12 pl-3 pr-3">
                        <div className="col-12 text-center p-0 py-3 active pcTitle">현대캐피탈 신차할부 신차패키지 서비스</div>
                    </div>

                    <div className="text-right w-100">
                        <span className="btn mt-3 text-lightgray" onClick={goBack}>뒤로가기</span>
                    </div>
                    <LoadService
                        s_id={s_id}
                        option={option}
                        setOption={setOption}
                        goCart={goCart}
                        onClick={onClick}
                    />

                </Row>
            </Container>
        </>

    );
}



export default Pc_ServiceInfo;